import { CenteredCard } from "../../components/centered-card";
import { MiniApp } from "../../components/mini-app";

export default function (ctx) {
    return CenteredCard(
        MiniApp({ sameWindow: true, classList: ["miniapp-page"] }),
        {
            style: {
                minHeight: "400px",
                width: "100%",
                maxWidth: "800px",
                overflowY: "auto"
            }
        }
    );
}